/**
* Scrolling Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Cards component.
*/

/**
* Example of importing modules if needed. Like for scroll magic / gsap
*/
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    className: 'scrolling-cards',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      if ( window.innerWidth < 1024 ) return;

      $( '.scrolling-cards' ).each( function( key, component ) {
        const $component = $( component );
        const navHeight = $( '.navbar' ).height() || 0;
        const adminbarHeight = $( '#wpadminbar' ).length ? $( '#wpadminbar' ).height() : 0;
        const topOffset = navHeight + adminbarHeight;

        const $cardContainer = $component.find( '.scrolling-cards__card-container-inner' );
        const containerHeight = $cardContainer.outerHeight( true );
        const viewportHeight = $( window ).height();
        const startY = viewportHeight;
        const endY = -containerHeight;

        gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            start: `top ${topOffset}`,
            end: () => `+=${containerHeight + viewportHeight}`,
            scrub: 1,
            pin: $component.find( '.scrolling-cards__inner' ),
          },
        } ).fromTo(
            $cardContainer,
            {y: startY},
            {y: endY, ease: 'none'},
        );
      } );
    },
    finalize: function() {},
  };
  app.registerComponent( 'scrolling-cards', COMPONENT );
} )( app );
